<div class="pre-audit-date">


	<nb-checkbox [checked]="product.additionalQuestions.initialCertificationQuestions.preAuditRequested" (click)="$event.stopPropagation(); $event.preventDefault()"
				 style="width: 30px; height: 30px"></nb-checkbox>
	<div class="pre-audit-with-change-label-wrapper">
		@if (showPricing) {
			<span class="pre-audit-label"
				  [display-in-one-line]="'etapa 1'">{{ 'additional-questions.audit-dates.pre-audit-request-with-price' | translate: {price: preAuditCost() | price | async} }}</span>
		} @else {
			{{ 'additional-questions.audit-dates.pre-audit-request-no-price' | translate: {manday: preAuditMandays | number} }}
		}
		<change-label [changeSet]="changeSet" [visible]="preAuditRequestChanged()"></change-label>
	</div>

</div>

<div class="client-property-label">
	<span>{{ 'additional-questions.audit-dates.pre-audit-date' | translate }}</span>
	<change-label [visible]="isDesiredPreAuditDateChanged()" [changeSet]="changeSet"></change-label>
</div>
<div class="client-property">
	@if (product.additionalQuestions.initialCertificationQuestions.desiredPreAuditDate) {
		<span>{{ product.additionalQuestions.initialCertificationQuestions.desiredPreAuditDate | localizedDate | async }}</span>
	}
	@if (!product.additionalQuestions.initialCertificationQuestions.desiredPreAuditDate) {
		<span class="placeholder">{{ 'additional-questions.audit-dates.date-not-provided' | translate }}</span>
	}
</div>

<div class="client-property-label">
	<span>{{ 'additional-questions.audit-dates.stage-1-date' | translate }}</span>
	<change-label [visible]="isDesiredStage1DateChanged()" [changeSet]="changeSet"></change-label>
</div>
<div class="client-property">
	@if (product.additionalQuestions.initialCertificationQuestions.desiredStage1AuditDate) {
		<span>{{ product.additionalQuestions.initialCertificationQuestions.desiredStage1AuditDate | localizedDate | async }}</span>
	}
	@if (!product.additionalQuestions.initialCertificationQuestions.desiredStage1AuditDate) {
		<span class="placeholder">{{ 'additional-questions.audit-dates.date-not-provided' | translate }}</span>
	}
</div>

<div class="client-property-label">
	<span>{{ 'additional-questions.audit-dates.stage-2-date' | translate }}</span>
	<change-label [visible]="isDesiredStage2DateChanged()" [changeSet]="changeSet"></change-label>
</div>
<div class="client-property">
	@if (product.additionalQuestions.desiredNextAuditDate) {
		<span>{{ product.additionalQuestions.desiredNextAuditDate | localizedDate | async }}</span>
	}
	@if (!product.additionalQuestions.desiredNextAuditDate) {
		<span class="placeholder">{{ 'additional-questions.audit-dates.date-not-provided' | translate }}</span>
	}
</div>
